import React from "react";
import "./AboutUs.css";

export default function AboutUs() {
  return (
    <section className="about-section" id="about-section">
      <div className="about-container">
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            MediMetrics began with a mission to make prosthetic care accessible to anyone,
            anywhere. We recognized that countless people around the world were unable to
            receive proper healthcare simply because of their location. By creating a
            platform where healthcare providers could gather accurate client measurements
            remotely, we eliminated one of the greatest barriers to life-altering medical
            support.
            <br /><br />
            Over time, our vision expanded. What started as a focus on prosthetics has grown
            into a broader solution that supports multiple healthcare applications. Today,
            MediMetrics continues to bridge the gap between patients and providers, ensuring
            that distance is never the reason someone goes without the care they deserve.     

          </p>
        </div>
        <div className="about-image">
          <img
            src={require("./assets/AboutUs-Img.jpg")} 
            alt="About Us"
          />
        </div>
      </div>
    </section>
  );
}
